export function FlagIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.003 2H5a1 1 0 00-1 1v18a1 1 0 102 0v-8h2.889c.628 0 1.161.314 1.994.844l.055.035C11.685 14.355 12.698 15 14 15c1.255 0 2.69-.602 3.697-1.106a19.81 19.81 0 001.815-1.034l.03-.02.008-.005.005-.003L19 12l.555.832A1 1 0 0020 12V3a1 1 0 00-1.555-.832l-.004.003-.021.014-.09.057c-.08.05-.197.124-.345.213-.296.178-.71.415-1.182.65C15.81 3.603 14.745 4 14 4c-.658 0-1.186-.315-1.975-.835l-.083-.055C11.233 2.64 10.264 2 9 2H5.003zM6 4v7h2.889c1.255 0 2.248.633 2.98 1.1l.087.056c.82.522 1.378.844 2.044.844.745 0 1.81-.398 2.803-.894.471-.236.886-.473 1.182-.651l.015-.009V4.74c-.098.052-.2.104-.303.155C16.69 5.398 15.255 6 14 6c-1.31 0-2.3-.653-3.024-1.131l-.051-.034C10.123 4.306 9.619 4 9 4H6z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
